export default __webpack_public_path__ + "static/media/oldfog1.b8c446fb.png";